import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_HOST } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class AdminApiService {

    constructor(private http: HttpClient) { }

    /**
     * GET /admin/statistics/tour
     * Statystyki przewodnika po systemie
     */
    public getTourStats(): Observable<any> {
        return this.http.get(`${API_HOST}admin/statistics/tour`);
    }

    /**
     * DELETE /admin/statistics/tour/:id
     * Usuwa feedback z przewodnika
     */
    public deleteTourFeedback(id: string): Observable<any> {
        return this.http.delete(`${API_HOST}admin/statistics/tour/${encodeURIComponent(id)}`);
    }
}
